


























import Vue from 'vue';
import { onAuthUIStateChange, AuthState } from '@aws-amplify/ui-components';
import { Auth } from 'aws-amplify';
import { mapState, mapActions } from 'vuex';

export default Vue.extend({
  name: 'UserPage',
  data() {
    return {
      authState: '' as AuthState,
      authData: {} as any,
      critterTypes: ['bugs', 'fish', 'sea'],
      formFields: [{ type: 'email' }, { type: 'password' }],
    };
  },
  created() {
    onAuthUIStateChange(async (authState, authData) => {
      this.authState = authState;
      this.authData = authData;
      if (this.authData && this.authData.attributes) {
        await this.getUserCritterInfo(this.authData.attributes.sub);
        this.critterTypes.forEach(
          async (critterName: string) => await this.getCritterList(critterName),
        );
      } else {
        await this.deleteUserCritterInfo();
      }
    });
  },
  computed: {
    ...mapState({
      user: (state: any) => state.user.user,
      totalCritters: (state: any) => state.totalCritters,
    }),
  },
  methods: {
    ...mapActions('user', ['getUserCritterInfo', 'deleteUserCritterInfo']),
    ...mapActions('totalCritters', ['getCritterList']),
    async deleteUserAccount() {
      try {
        const user = await Auth.currentAuthenticatedUser();
        user.deleteUser(error => {
          if (error) {
            throw error;
          }
        });
        await Auth.signOut();
        await this.deleteUserCritterInfo();
      } catch (err) {
        console.log(err);
      }
    },
  },
});
